import React from 'react';
import { ZALO_LINK } from '../constants/links';
import { PHONE_DISPLAY, SOCIAL_LINKS, TEL_LINK } from '../constants/site-data';

const labelClass = 'text-[13px] font-bold uppercase tracking-[0.08em] text-muted';
const linkClass = 'text-base font-semibold text-accent hover:text-accent-dark';

function ContactInfo() {
  return (
    <>
      <section id="contact" className="bg-white">
        <div className="page-container pb-[72px] pt-24">
          <div className="flex flex-wrap items-center justify-between gap-10 rounded-[32px] bg-accent p-8 text-white sm:p-12">
            <div className="flex min-w-0 flex-[1_1_420px] flex-col gap-3">
              <h2 className="m-0 font-display text-[clamp(2rem,3.6vw,2.8rem)] font-extrabold leading-[1.05] tracking-[-0.02em]">
                Thèm bánh tráng? Nhắn Gà Kitchen nhé.
              </h2>
              <p className="m-0 text-[17px] text-[#FFF1E6]">
                Nhận đơn lẻ và sỉ qua Zalo hoặc điện thoại, mỗi ngày 8:00 – 21:00.
              </p>
            </div>
            <div className="flex flex-wrap gap-3">
              <a
                href={ZALO_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-lg bg-white text-forest hover:bg-cream hover:text-forest"
              >
                Nhắn Zalo
              </a>
              <a href={TEL_LINK} className="btn btn-lg border-[1.5px] border-white/60 text-white hover:border-white hover:text-white">
                {PHONE_DISPLAY}
              </a>
            </div>
          </div>

          <div className="grid grid-cols-[repeat(auto-fit,minmax(240px,1fr))] gap-8 pt-14">
            <div className="flex flex-col gap-2">
              <h3 className={labelClass}>Địa chỉ</h3>
              <address className="text-base not-italic">
                Yên Khê Hạ, Lạc Lâm
                <br />
                Đơn Dương, Lâm Đồng
              </address>
            </div>
            <div className="flex flex-col gap-2">
              <h3 className={labelClass}>Giờ làm việc</h3>
              <p className="m-0 text-base">
                Thứ 2 – Chủ nhật
                <br />
                8:00 – 21:00
              </p>
            </div>
            <div className="flex flex-col gap-2">
              <h3 className={labelClass}>Liên hệ</h3>
              <a href={ZALO_LINK} target="_blank" rel="noopener noreferrer" className={linkClass}>
                Zalo: {PHONE_DISPLAY}
              </a>
              <a href={TEL_LINK} className={linkClass}>
                Gọi: {PHONE_DISPLAY}
              </a>
            </div>
            <div className="flex flex-col gap-2">
              <h3 className={labelClass}>Theo dõi &amp; mua online</h3>
              <div className="flex flex-wrap gap-2">
                {SOCIAL_LINKS.map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex min-h-[44px] items-center rounded-full border-[1.5px] border-line-strong px-4 py-2 text-sm font-semibold text-ink no-underline hover:border-forest hover:text-ink"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="border-t border-line-soft">
        <div className="page-container flex flex-wrap justify-between gap-3 py-6 text-sm text-muted">
          <span>© {new Date().getFullYear()} Gà Kitchen. Đã đăng ký bản quyền.</span>
          <span>Bánh tráng mắm ruốc · Sa tế tôm · Phồng chuối nướng — Đặc sản Đà Lạt</span>
        </div>
      </footer>
    </>
  );
}

export default ContactInfo;
